import constants from '../constants';

export const accountLink = (account: string): string | undefined => {
  if (account !== undefined && account !== null && account.length > 0) {
    const baseAddress = constants.nodeExplorer.account;
    const url = baseAddress.replace('${account}', account);
    return url;
  }
  return;
};